import { getOneCMSInternetSSRApiUrl } from '../selectors/getBaseUrlSelectors';

export default {
  fetch: (contentPath, action, state) => ({
    url: `${getOneCMSInternetSSRApiUrl(state)}/${contentPath}`,
    opts: {
      credentials: 'omit',
    },
  }),
};
